import { Button } from "@4uhub/lib4uhub";
import { Box, Chip } from "@mui/material";
import { memo, useCallback, useState } from "react";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import EventBusyRoundedIcon from "@mui/icons-material/EventBusyRounded";
import { useTranslation } from "react-i18next";
import { CancelModal } from "./CancelModal/CancelModal";
import { IActionsProps } from "./models";

const TRANSLATION_PATH = "page.topmedSchedule.mySchedules.";

export const Actions = memo(({ props, onRefresh }: IActionsProps) => {
  const {
    hash,
    date,
    patientName,
    situation,
    situationName,
    urlTeleconsultation,
  } = props;

  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  const today = new Date();

  const scheduleDate = new Date(date);

  const openHandler = useCallback(() => {
    setOpen(true);
  }, []);

  const closeHandler = useCallback(() => {
    setOpen(false);
  }, []);

  const redirectHandler = useCallback(() => {
    window.open(urlTeleconsultation, "_blank");
  }, [urlTeleconsultation]);

  if (situation === "3") {
    return <Chip label={t(TRANSLATION_PATH + "canceled")} />;
  }

  if (scheduleDate < today) {
    return <Chip variant="outlined" label={t(TRANSLATION_PATH + "expired")} />;
  }

  if (situation !== "1") {
    return <Chip label={situationName} />;
  }

  return (
    <>
      <CancelModal
        date={date}
        patient={patientName}
        hash={hash}
        open={open}
        onClose={closeHandler}
        onRefresh={onRefresh}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          gap: 1,
        }}
      >
        <Button
          variant="contained"
          size="small"
          startIcon={<OpenInNewRoundedIcon />}
          onClick={redirectHandler}
        >
          {t(TRANSLATION_PATH + "access_room")}
        </Button>
        <Button
          size="small"
          startIcon={<EventBusyRoundedIcon />}
          onClick={openHandler}
        >
          {t(TRANSLATION_PATH + "cancel")}
        </Button>
      </Box>
    </>
  );
});
